<div id="navigation">
  <div class="profile-picture">
    <i class="material-icons md-48">account_circle</i>
    <div class="stats-label text-color">
      <span class="font-extra-bold font-uppercase"
        >{{ firstname }} {{ lastname }}</span
      >

      <div class="dropdown" dropdown>
        <a dropdown-toggle class="dropdown-toggle" data-toggle="dropdown">
          <small class="text-muted">logged in user<b class="caret"></b></small>
        </a>
        <ul class="dropdown-menu am-t-xs">
          <li>
            <a>View Profile (Not Implemented)</a>
          </li>
          <li class="divider"></li>
          <li><a (click)="logout()">Logout</a></li>
        </ul>
      </div>
    </div>
  </div>
  <ul
    side-navigation
    class="nav"
    id="side-menu"
    [ngClass]="{ in: _router.url === '/home' }"
  >
    <li [routerLink]="['/home']" [routerLinkActive]="'active'">
      <a>
        <span class="nav-label">Connect</span>
      </a>
    </li>
    <li [ngClass]="{ active: _router.url.includes('setup') }">
      <a>
        <span class="nav-label">Setup</span>
      </a>
      <ul
        class="nav nav-second-level"
        [ngClass]="{ in: _router.url.includes('/setup') }"
      >
        <li [routerLink]="['/setupimport']" [routerLinkActive]="'active'">
          <a>Import QB Customers</a>
        </li>
        <li
          [routerLink]="['/setupimportvendors']"
          [routerLinkActive]="'active'"
        >
          <a>Import QB Vendors</a>
        </li>
        <li
          *ngIf="!isFreemium()"
          [routerLink]="['/setupcostcodes']"
          [routerLinkActive]="'active'"
        >
          <a>Link Service Items</a>
        </li>
        <li
          *ngIf="!isFreemium()"
          [routerLink]="['/setupclasses']"
          [routerLinkActive]="'active'"
        >
          <a>Link Classes</a>
        </li>
        <li
          *ngIf="!isFreemium()"
          [routerLink]="['/setupjobs']"
          [routerLinkActive]="'active'"
        >
          <a>Link Customers</a>
        </li>
        <li
          *ngIf="!isFreemium()"
          [routerLink]="['/setupvendors']"
          [routerLinkActive]="'active'"
        >
          <a>Link Vendors</a>
        </li>
        <li
          *ngIf="!isFreemium()"
          [routerLink]="['/setupstaff']"
          [routerLinkActive]="'active'"
        >
          <a>Link Staff</a>
        </li>
        <li
          *ngIf="!isFreemium()"
          [routerLink]="['/setuptaxes']"
          [routerLinkActive]="'active'"
        >
          <a>Link Tax Codes</a>
        </li>
        <li
          *ngIf="!isFreemium()"
          [routerLink]="['/setuppaymethods']"
          [routerLinkActive]="'active'"
        >
          <a>Link Pay Methods</a>
        </li>
      </ul>
    </li>
    <li
      *ngIf="!isFreemium() && !isFranchise('GUY')"
      [ngClass]="{ active: _router.url.includes('estimate') }"
    >
      <a>
        <span class="nav-label">Estimates</span>
      </a>
      <ul
        class="nav nav-second-level"
        [ngClass]="{ in: _router.url.includes('estimate') }"
      >
        <li [routerLink]="['/estimatesync']" [routerLinkActive]="'active'">
          <a>Publish Estimates</a>
        </li>
        <li [routerLink]="['/estimatesettings']" [routerLinkActive]="'active'">
          <a>Settings</a>
        </li>
      </ul>
    </li>
    <li
      *ngIf="!isFreemium()"
      [ngClass]="{ active: _router.url.includes('invoice') }"
    >
      <a>
        <span class="nav-label">Invoices</span>
      </a>
      <ul
        class="nav nav-second-level"
        [ngClass]="{ in: _router.url.includes('invoice') }"
      >
        <li [routerLink]="['/invoicesync']" [routerLinkActive]="'active'">
          <a>Publish Invoices</a>
        </li>
        <li [routerLink]="['/invoicesettings']" [routerLinkActive]="'active'">
          <a>Settings</a>
        </li>
      </ul>
    </li>
    <li
      *ngIf="!isFreemium()"
      [ngClass]="{ active: _router.url.includes('time') }"
    >
      <a>
        <span class="nav-label">Timesheets</span>
      </a>
      <ul
        class="nav nav-second-level"
        [ngClass]="{ in: _router.url.includes('time') }"
      >
        <li [routerLink]="['/timesync']" [routerLinkActive]="'active'">
          <a>Publish Timesheets</a>
        </li>
        <li [routerLink]="['/timesettings']" [routerLinkActive]="'active'">
          <a>Settings</a>
        </li>
      </ul>
    </li>
    <li
      *ngIf="!isFreemium()"
      [ngClass]="{ active: _router.url.includes('vendorbil') }"
    >
      <a>
        <span class="nav-label">Vendor Bills</span>
      </a>
      <ul
        class="nav nav-second-level"
        [ngClass]="{ in: _router.url.includes('vendorbill') }"
      >
        <li [routerLink]="['/vendorbillsync']" [routerLinkActive]="'active'">
          <a>Publish Vendor Bills</a>
        </li>
        <li
          [routerLink]="['/vendorbillsettings']"
          [routerLinkActive]="'active'"
        >
          <a>Settings</a>
        </li>
      </ul>
    </li>
    <li
      *ngIf="!isFreemium()"
      [ngClass]="{ active: _router.url.includes('payment') }"
    >
      <a>
        <span class="nav-label">Payments</span>
      </a>
      <ul
        class="nav nav-second-level"
        [ngClass]="{ in: _router.url.includes('payment') }"
      >
        <li [routerLink]="['/paymentsync']" [routerLinkActive]="'active'">
          <a>Publish Payments</a>
        </li>
        <li [routerLink]="['/paymentsettings']" [routerLinkActive]="'active'">
          <a>Settings</a>
        </li>
      </ul>
    </li>
    <li [ngClass]="{ active: _router.url.includes('status') }">
      <a>
        <span class="nav-label">Status</span>
      </a>
      <ul
        class="nav nav-second-level"
        [ngClass]="{ in: _router.url.includes('status') }"
      >
        <li [routerLink]="['/status']" [routerLinkActive]="'active'">
          <a>Job Status</a>
        </li>
      </ul>
    </li>
    <li>
      <a href="https://academy.golmn.com/learn" target="_blank">
        <span class="nav-label">LMN Academy</span>
      </a>
    </li>
  </ul>
</div>
